class QuickAddToCart extends HTMLElement {
	constructor(){
		super();
		if ( this.querySelector('product-form') ) {
			this.init();
		}
	}
	init(){
		this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
			if ( ! document.body.classList.contains('template-cart') ) {
	 			document.getElementById('site-cart').show();
	 			if ( document.getElementById('cart-recommendations') ) {
	        document.getElementById('cart-recommendations').generateRecommendations();
	      }
			} else {
				document.querySelector('#section-cart .box__text').scrollIntoView();
  			document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
			}
 		});
	}
}

customElements.define('quick-add-to-cart', QuickAddToCart);

class QuickViewProduct extends HTMLElement {
	constructor(){
		super();
		if ( this.querySelector('button') ) {
			this.init();
		}
	}
	init(){

		this.quickViewModal = null;
		this.querySelector('button').addEventListener('click', (e)=>{

			e.preventDefault();

			if ( ! this.quickViewModal ) {

				const target = e.currentTarget;

				target.classList.add('working');

				fetch(`${target.getAttribute('data-href')}${ target.getAttribute('data-href').includes('?') ? '&' : '?' }view=quick-view`)
					.then(response => response.text())
					.then(text => {

						// create modal w content

	        	const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.product-quick-view');
	        	this.quickViewModal = basicLightbox.create(quickViewHTML, { className: 'basicLightbox--quick-buy' });
	        	this.quickViewModal.show();
	        	target.classList.remove('working');

						// setup images for variant selector

						const quickProduct = this.quickViewModal.element();
						const quickProductImage = quickProduct.querySelector('.product-images img');
						const quickViewImages = JSON.parse(quickProduct.querySelector('.product-images').querySelector('[type="application/json"]').textContent);

						const productVariants = quickProduct.querySelector('product-variants');
						if ( productVariants ) {
							productVariants.addEventListener('VARIANT_CHANGE', (e)=>{
								const variant = e.target.currentVariant;
								if ( variant && variant.featured_media != null && quickViewImages[variant.featured_media.id] != null ) {
									const newSrcset = quickViewImages[variant.featured_media.id];
									if ( quickProductImage.getAttribute('srcset') !== newSrcset ) {
										quickProductImage.setAttribute('srcset', newSrcset);
									}
								}
							})
						}

						// setup add to cart functionality

					 	if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				 			let addToCartEnter = false;
							if ( quickProduct.querySelector('.product--add-to-cart-button') ) {
						 		quickProduct.querySelector('.product--add-to-cart-button').addEventListener('keyup', e=>{
									if ( e.keyCode == window.KEYCODES.RETURN ) {
										addToCartEnter = true;
									}
						 		})
						 	}

						 	if ( quickProduct.querySelector('.product--add-to-cart-form') ) {
						 		quickProduct.querySelector('.product--add-to-cart-form').addEventListener('add-to-cart', ()=>{
						 			document.getElementById('site-cart').show();
									 this.quickViewModal.close();
						 			if ( document.getElementById('cart-recommendations') ) {
						        document.getElementById('cart-recommendations').generateRecommendations();
					        }
						 			if ( addToCartEnter ) {
										setTimeout(()=>{
											document.querySelector('#site-cart .site-close-handle').focus();
										}, 200);
						 			}
						 		});
						 	}

					 	}

	        });

			} else {
      	this.quickViewModal.show();
			}

		})
	}
}

customElements.define('quick-view-product', QuickViewProduct);

class CartQuickSizes extends HTMLElement {
	constructor() {
		super();
		this._selector = null;
		this._productItem = null;
		this._onMouseLeave = this._dismiss.bind(this);
		this.querySelector('button').addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelectorAll('cart-quick-sizes.is-active').forEach(el => {
				if (el !== this) el._dismiss();
			});
			this.classList.contains('is-active') ? this._dismiss() : this._show();
		});
	}

	_show() {
		this._productItem = this.closest('[data-js-product-item]');
		this._selector = this._productItem.querySelector('.cart-size-selector');
		if (!this._selector) return;

		if (!this._selector.dataset.initialized) {
			this._selector.dataset.initialized = 'true';
			this._selector.querySelectorAll('.cart-size-btn:not(:disabled)').forEach(btn => {
				btn.addEventListener('click', () => this._addToCart(btn.dataset.variantId));
			});
		}

		requestAnimationFrame(() => this._selector.classList.add('is-visible'));
		this.classList.add('is-active');
		this._productItem.addEventListener('mouseleave', this._onMouseLeave);
	}

	_dismiss() {
		if (!this._selector) return;
		this._selector.classList.remove('is-visible');
		this.classList.remove('is-active');
		this._productItem.removeEventListener('mouseleave', this._onMouseLeave);
	}

	_addToCart(variantId) {
		this._dismiss();
		const btn = this.querySelector('button');
		btn.classList.add('working');
		fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
		})
		.then(r => r.json())
		.then(() => {
			btn.classList.remove('working');
			if (!document.body.classList.contains('template-cart')) {
				fetch('?section_id=helper-cart')
					.then(r => r.text())
					.then(text => {
						const doc = new DOMParser().parseFromString(text, 'text/html');
						const cartItems = document.getElementById('AjaxCartForm');
						cartItems.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
						cartItems.ajaxifyCartItems();
						document.querySelectorAll('[data-header-cart-count]').forEach(el => {
							el.textContent = cartItems.querySelector('[data-cart-count]').textContent;
						});
						document.querySelectorAll('[data-header-cart-total]').forEach(el => {
							el.textContent = cartItems.querySelector('[data-cart-total]').textContent;
						});
						document.getElementById('AjaxCartSubtotal').innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;

						// Move newest item (Shopify puts it first) to the bottom of the list
						const firstItem = cartItems.querySelector('[data-js-cart-item]');
						if (firstItem) firstItem.parentNode.appendChild(firstItem);

						// Scroll cart down to reveal the newly added item
						const scrollContainer = document.querySelector('.site-nav-container');
						if (scrollContainer) scrollContainer.scrollTop = scrollContainer.scrollHeight;

						const cartSidebar = document.querySelector('[data-js-site-cart-sidebar]');
						if (cartSidebar && !cartSidebar.classList.contains('active')) cartSidebar.show();
					});
			}
		})
		.catch(() => btn.classList.remove('working'));
	}
}

customElements.define('cart-quick-sizes', CartQuickSizes);